import React from 'react';
import { Phone, Mail, MapPin, ArrowUp } from 'lucide-react';
import { companyInfo, navLinks } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#252A32] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-11 h-11 rounded-md bg-[#B8956B] flex items-center justify-center">
                <span className="text-white font-bold text-lg heading-display">B</span>
              </div>
              <div>
                <h3 className="font-semibold text-xl">Becone</h3>
                <p className="text-gray-500 text-[10px] uppercase tracking-[0.2em]">Elevators</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {companyInfo.tagline}. Premium elevator solutions with 30+ years of 
              engineering excellence.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <span>GST: {companyInfo.gstNumber}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-[#B8956B] transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Our Products</h4>
            <ul className="space-y-3">
              {[
                'Passenger Elevators',
                'Home Lifts',
                'Gearless MRL Lifts',
                'Geared Elevators',
                'Car Lifts',
                'Goods Lifts'
              ].map((product, idx) => (
                <li key={idx}>
                  <button
                    onClick={() => scrollToSection('products')}
                    className="text-gray-400 hover:text-[#B8956B] transition-colors"
                  >
                    {product}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#B8956B] mt-1 flex-shrink-0" />
                <div className="space-y-1">
                  {companyInfo.phones.map((phone, idx) => (
                    <a 
                      key={idx}
                      href={`tel:${phone}`}
                      className="block text-gray-400 hover:text-[#B8956B] transition-colors"
                    >
                      +91 {phone}
                    </a>
                  ))}
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#B8956B] flex-shrink-0" />
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-400 hover:text-[#B8956B] transition-colors"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#B8956B] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  {companyInfo.address.full}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Becone Elevators. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-gray-500 text-sm">IS 17900:2022 Compliant</span>
              <button
                onClick={scrollToTop}
                className="w-10 h-10 rounded-full bg-[#B8956B]/10 hover:bg-[#B8956B] flex items-center justify-center transition-colors group"
              >
                <ArrowUp className="w-4 h-4 text-[#B8956B] group-hover:text-white transition-colors" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
